import { render, staticRenderFns } from "./saveClueFollowRemark.vue?vue&type=template&id=04784c60&scoped=true"
import script from "./saveClueFollowRemark.vue?vue&type=script&lang=js"
export * from "./saveClueFollowRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04784c60",
  null
  
)

export default component.exports